{
  "reviewStatus": "proposal",
  "note": "Six fictional clubs in an unnamed desert metro (spec §18, OPEN_QUESTIONS #14) plus four guest clubs met only at tournaments (never in the league, never at tryouts). Names, attractions and quality are proposals.",
  "clubs": [
    {
      "id": "batavia",
      "name": "FC Batavia",
      "shortName": "BAT",
      "attraction": "A new team with a coach who teaches the game and gives young players real minutes.",
      "quality": 48,
      "colors": { "primary": "#0b2545", "secondary": "#4fd1ff" },
      "reviewStatus": "proposal"
    },
    {
      "id": "sonoran",
      "name": "Sonoran United",
      "shortName": "SON",
      "attraction": "The strongest youth program in the valley: tournament wins, exposure and a full-time technical staff.",
      "quality": 63,
      "colors": { "primary": "#8b1e1e", "secondary": "#f2c14e" },
      "reviewStatus": "proposal"
    },
    {
      "id": "camelback",
      "name": "Camelback Athletic",
      "shortName": "CAM",
      "attraction": "Superb individual technical coaching; every player leaves a better dribbler.",
      "quality": 58,
      "colors": { "primary": "#1f6f43", "secondary": "#ffffff" },
      "reviewStatus": "proposal"
    },
    {
      "id": "mesaverde",
      "name": "Mesa Verde SC",
      "shortName": "MVS",
      "attraction": "A family club with the best facilities in the east valley and a calm, patient culture.",
      "quality": 53,
      "colors": { "primary": "#3a2d7a", "secondary": "#e0d6ff" },
      "reviewStatus": "proposal"
    },
    {
      "id": "saguaro",
      "name": "Saguaro Rangers",
      "shortName": "SAG",
      "attraction": "Play everyone, travel little, and win more than people expect.",
      "quality": 50,
      "colors": { "primary": "#3d6b2a", "secondary": "#f7f3d0" },
      "reviewStatus": "proposal"
    },
    {
      "id": "redrock",
      "name": "Red Rock FC",
      "shortName": "RRF",
      "attraction": "A goalkeeper-first academy whose coaches once played in the professional game.",
      "quality": 46,
      "colors": { "primary": "#b24a1a", "secondary": "#1a1a1a" },
      "reviewStatus": "proposal"
    },
    {
      "id": "coastal",
      "name": "Coastal Breakers",
      "shortName": "CST",
      "attraction": "A big beach-city club that travels to every cup with two full sides.",
      "quality": 60,
      "colors": { "primary": "#0a6e8a", "secondary": "#ffe08a" },
      "guest": true,
      "reviewStatus": "proposal"
    },
    {
      "id": "highdesert",
      "name": "High Desert Rovers",
      "shortName": "HDR",
      "attraction": "A small-town club that runs all day and never stops talking.",
      "quality": 51,
      "colors": { "primary": "#5b4a2f", "secondary": "#f4e7c3" },
      "guest": true,
      "reviewStatus": "proposal"
    },
    {
      "id": "pinnacle",
      "name": "Pinnacle Peak FC",
      "shortName": "PPK",
      "attraction": "North-valley club with a strong keeper school and a very organised back line.",
      "quality": 56,
      "colors": { "primary": "#2b2b6e", "secondary": "#ff9f43" },
      "guest": true,
      "reviewStatus": "proposal"
    },
    {
      "id": "riosalado",
      "name": "Rio Salado SC",
      "shortName": "RSS",
      "attraction": "A friendly, mixed-ability club that enters every cup for the experience.",
      "quality": 47,
      "colors": { "primary": "#1c7c54", "secondary": "#c1f0d2" },
      "guest": true,
      "reviewStatus": "proposal"
    }
  ]
}
